// extracted by mini-css-extract-plugin
export default {"name":"profile_card_name-module___name___b75cb1fa"};